export const nhaCungCap = {
  sections: {
    list: { title: 'Nhà cung cấp' },
    general: 'Thông tin chung',
  },
  stats: {
    total: 'Tổng {count}',
    activeOnPage: 'Hoạt động (trang): {count}',
    inactiveOnPage: 'Ngừng (trang): {count}',
  },
  fields: {
    code: 'Mã NCC',
    name: 'Tên nhà cung cấp',
    classification: 'Phân loại',
    phone: 'Điện thoại',
    email: 'Email',
    address: 'Địa chỉ',
    province: 'Tỉnh/Thành',
    area: 'Khu vực',
    ward: 'Phường/Xã',
    groups: 'Nhóm NCC',
    groupCode: 'Mã nhóm NCC',
    groupName: 'Tên nhóm NCC',
    note: 'Ghi chú',
    companyName: 'Tên công ty',
    taxCode: 'Mã số thuế',
    totalPurchase: 'Tổng mua',
    debt: 'Nợ cần trả hiện tại',
    totalPurchaseNet: 'Tổng mua trừ trả hàng',
    branch: 'Chi nhánh',
    createdBy: 'Người tạo',
    onOffAction: 'Bật / Tắt',
    status: 'Trạng thái',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
    actions: 'Thao tác',
  },
  aria: {
    columnPicker: 'Chọn cột hiển thị',
  },
  status: {
    dangHoatDong: 'Đang hoạt động',
    ngungHoatDong: 'Ngừng hoạt động',
    all: 'Tất cả',
  },
  sort: {
    maNhaCungCap: 'Mã NCC',
    tenNhaCungCap: 'Tên NCC',
    ngayTao: 'Ngày tạo',
    trangThai: 'Trạng thái',
  },
  filter: {
    searchPlaceholder: 'Tìm kiếm',
    textDetailTitle: 'Bộ lọc chi tiết',
    group: 'Nhóm NCC',
    statusSection: 'Trạng thái',
    groupSection: 'Nhóm nhà cung cấp',
    sortSection: 'Sắp xếp',
    sortField: 'Trường sắp xếp',
    sortDir: 'Chiều sắp xếp',
  },
  titles: { add: 'Thêm nhà cung cấp', edit: 'Sửa nhà cung cấp', detail: 'Chi tiết nhà cung cấp' },
  placeholders: {
    codeAuto: 'Mã tự động',
    province: 'Chọn tỉnh/thành',
    ward: 'Chọn phường/xã',
  },
  validation: {
    nameRequired: 'Vui lòng nhập tên nhà cung cấp',
    phoneInvalid: 'Điện thoại không hợp lệ (8–15 chữ số)',
    emailInvalid: 'Email không hợp lệ',
    taxCodeInvalid: 'Mã số thuế không hợp lệ (10 hoặc 13 chữ số)',
  },
  messages: {
    noData: 'Không có dữ liệu',
    loadError: 'Không tải được dữ liệu',
    loadDetailError: 'Không tải được chi tiết',
    createSuccess: 'Đã tạo nhà cung cấp',
    updateSuccess: 'Đã cập nhật nhà cung cấp',
    deleteSuccess: 'Đã xóa nhà cung cấp',
    toggleSuccess: 'Đã đổi trạng thái',
    confirmDelete: 'Xóa nhà cung cấp «{name}»?',
    listSummary: 'Tổng số {count} nhà cung cấp',
    selectedCount: 'Đã chọn: {count}',
    deleteSelected: 'Xóa đã chọn ({count})',
    bulkDeleteConfirm: 'Xóa {count} nhà cung cấp đã chọn? (Xóa từng nhà cung cấp qua API.)',
    bulkDeleteSuccess: 'Đã xóa {count} nhà cung cấp',
    bulkDeletePartial: 'Đã xóa {ok}/{total}. {failed} nhà cung cấp không xóa được.',
    bulkDeleteError: 'Xóa hàng loạt thất bại',
    bulkDeleteNoneSelected: 'Chưa chọn nhà cung cấp nào để xóa',
  },
  import: {
    description: 'Chọn file Excel theo mẫu tải về. Hệ thống xử lý import trên server.',
    success: 'Import nhà cung cấp thành công',
    failed: 'Import nhà cung cấp thất bại',
    capNhatDuNoCuoi: 'Cập nhật nợ cũ cuối kỳ',
  },
  detailTabs: {
    generalInfo: 'Thông tin',
    debt: 'Công nợ',
  },
  expandDebt: {
    hint: 'Lịch sử giao dịch công nợ sẽ hiển thị tại đây.',
  },
}
